class ForgotPasswordDelegate {
    setEmail(email) {
        this.setState({ email, error: null, elsewhere: null });
    }

    setCode(code) {
        this.setState({ code, error: null, codeRejected: false });
    }

    setPassword(password) {
        this.setState({ password, error: null });
    }

    setConfirm(confirm) {
        this.setState({ confirm, error: null });
    }

    togglePasswordVisibility() {
        this.setState((prev) => ({ passwordVisible: !prev.passwordVisible }));
    }
}

export default ForgotPasswordDelegate;
